
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import CompanyMetricsBtns from '@/views/Team/CompanyDashboard/CompanyMetricsBtns.vue';
import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs.vue';
import { ROUTER } from '@/router/constants';

export default Vue.extend({
	name: 'CompanyOverview',
	props: {
		// GET /api/v2/internal/teams/summary, camelCased (teamsApi.ts), or null before the first answer
		teamsSummary: { type: Object, default: null },
		loadingTeamsSummary: { type: Boolean, default: false },
	},
	data () {
		return {
		};
	},
	computed: {
		...mapGetters([
			'showStripeTeamSubscriptionPortalBtn',
		]),
		...mapState([
			'team',
			'appQueryParamsData',
		]),
		breadcrumbs () {
			return [
				{
					hoverColor: 'var(--primary-purple)',
					text: 'Company Dashboard',
					disabled: true,
					to: {
						name: ROUTER.COMPANY_DASHBOARD,
					},
				},
			];
		},
	},
	watch: {
		showStripeTeamSubscriptionPortalBtn (newVal: boolean, oldVal: boolean) {
			if (
				newVal !== oldVal &&
				newVal &&
				this.appQueryParamsData &&
				this.appQueryParamsData.openManageTeamSubscription
			) {
				// Auto open customer portal
				this.goToStripeSubscriptionPortal(this.team);
				// Reset openManageTeamSubscription to false
				this.updateAppQueryParamsData({ openManageTeamSubscription: false });
			}
		},
	},
	methods: {
		...mapActions([
			'goToStripeSubscriptionPortal',
			'updateAppQueryParamsData',
		]),
	},
	components: {
		BaseBreadcrumbs,
		CompanyMetricsBtns,
	},
});
